import { useAuth } from '../../contexts/AuthContext'
import TopNav from './TopNav'
import BottomNav from './BottomNav'

interface LayoutProps {
  children: React.ReactNode
}

export default function Layout({ children }: LayoutProps) {
  const { currentUser } = useAuth()
  const hasBottomNav = Boolean(currentUser && !currentUser.admin)

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <TopNav />
      <main className={`flex-1 ${hasBottomNav ? 'pb-20 md:pb-0' : ''}`}>
        {children}
      </main>
      <BottomNav />
    </div>
  )
}
